import { useInView } from '@hooks/useInView';
import * as React from 'react';
import S from '../../UmbracoForm.styles';
import * as recaptcha from './recaptcha';
const Recaptcha2 = React.forwardRef(({ dirty, error, value, onChange, siteKey, ...otherProps }, ref) => {
    const refRecaptcha = React.useRef(null);
    const [refContainer, inView] = useInView({});
    React.useEffect(() => {
        if (inView) {
            doAsync();
        }
        async function doAsync() {
            if (!refRecaptcha.current || !siteKey) {
                return;
            }
            await recaptcha.load();
            await recaptcha.execute(refRecaptcha.current, siteKey, callback);
        }
    }, [inView]);
    return (React.createElement(S.Field, { ref: refContainer, "data-dirty": dirty, "data-invalid": !!error },
        React.createElement("input", { type: "hidden", value: value, onChange: onChange, ...otherProps, ref: ref }),
        React.createElement("div", { ref: refRecaptcha }),
        error && React.createElement(S.Error, null, error.message)));
    function callback(token) {
        onChange(token);
    }
});
Recaptcha2.displayName = 'Recaptcha2';
export default Recaptcha2;
